module.exports = __webpack_public_path__ + "static/media/javascript.56da7542.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/stacks/images/javascript.jpg
// module id = 573
// module chunks = 0